<mat-card class="content-search-header mat-elevation-z3">
  <div
    class="d-md-flex justify-content-md-between align-items-center content-filters"
  >
    <div
      class="width-100 d-flex justify-content-between justify-content-md-start align-items-center"
    >
      <button
        pButton
        pRipple
        type="button"
        *ngIf="!hiddenFilter"
        [matMenuTriggerFor]="menuFilter"
        icon="pi pi-filter"
        class="p-button-rounded p-button-primary p-button-outlined mb-2 mr-2"
      ></button>
      <mat-menu #menuFilter="matMenu" class="text-center menu-content">
        <div class="content-itens-filter">
          <h6 class="my-2">Filtros avançados</h6>
          <mat-accordion (click)="$event.stopPropagation()">
            <mat-expansion-panel>
              <mat-expansion-panel-header>Status</mat-expansion-panel-header>

              <mat-list>
                <mat-selection-list [formControl]="statusForm">
                  <mat-list-option
                    checkboxPosition="before"
                    color="primary"
                    [value]="status.value"
                    *ngFor="let status of entityStatusList"
                  >
                    {{ status.label }}
                  </mat-list-option>
                </mat-selection-list>
              </mat-list>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-menu>

      <div id="fields-sections" class="mt-2">
        <!-- TEXTO -->

        <div [class]="classInputText1" *ngIf="showInput">
          <span class="p-float-label p-input-icon-right width-100">
            <i
              *ngIf="keywordFormInput1.value"
              (click)="clearFilter1()"
              id="search-keyword"
              class="text-danger pi pi-fw pi-times-circle cursor-pointer"
            >
            </i>
            <input
              type="text"
              id="inputtext-right"
              pInputText
              [formControl]="keywordFormInput1"
              [readonly]="readOnlyInput"
              min="0"
              [type]="typeInput1"
              oninput="validity.valid||(value='');"
              (keyup)="enterSearch($event)"
              class="input-filters"
            />
            <label for="inputtext-right">{{ placeHolder1 }}</label>
          </span>
        </div>

        <div [class]="classInputText2" *ngIf="showInput2">
          <span class="p-float-label p-input-icon-right width-100">
            <i
              *ngIf="keywordFormInput2.value"
              (click)="clearFilter2()"
              id="search-keyword"
              class="text-danger pi pi-fw pi-times-circle cursor-pointer"
            >
            </i>
            <input
              type="text"
              id="inputtext-right"
              pInputText
              [formControl]="keywordFormInput2"
              [readonly]="readOnlyInput"
              min="0"
              [type]="typeInput2"
              oninput="validity.valid||(value='');"
              [mask]="onlyUpperCase ? 'SSS' : ''"
              [value]="
                !onlyUpperCase ? '' : (keywordFormInput2.value | uppercase)
              "
              (keyup)="enterSearch($event)"
              class="input-filters"
            />
            <label for="inputtext-right">{{ placeHolder2 }}</label>
          </span>
        </div>

        <div [class]="classInputText3" *ngIf="showInput3">
          <span class="p-float-label p-input-icon-right width-100">
            <i
              *ngIf="keywordFormInput3.value"
              (click)="clearFilter3()"
              id="search-keyword"
              class="text-danger pi pi-fw pi-times-circle cursor-pointer"
            >
            </i>
            <input
              type="text"
              id="inputtext-right"
              pInputText
              [formControl]="keywordFormInput3"
              [readonly]="readOnlyInput"
              min="0"
              [type]="typeInput3"
              oninput="validity.valid||(value='');"
              (keyup)="enterSearch($event)"
              class="input-filters"
            />
            <label for="inputtext-right">{{ placeHolder3 }}</label>
          </span>
        </div>

        <!-- CPF/CNPJ -->

        <div [class]="classInputTextCpfCnpj" *ngIf="showInputCpfCnpj">
          <span class="p-float-label p-input-icon-right width-100">
            <i
              *ngIf="keywordCpf_Cnpj.value"
              (click)="clearFilterCpfCnpj()"
              id="search-keyword"
              class="text-danger pi pi-fw pi-times-circle cursor-pointer"
            >
            </i>
            <input
              type="text"
              id="inputtext-right"
              pInputText
              type="text"
              maxlength="18"
              [formControl]="keywordCpf_Cnpj"
              [mask]="cpfCnpjMask"
              (keyup)="enterSearch($event)"
              class="input-filters"
            />
            <label for="inputtext-right">{{ placeHolderCpfCnpj }}</label>
          </span>
        </div>

        <!-- NÚMERICOS -->

        <div [class]="classInputText4" *ngIf="showInput4">
          <span class="p-float-label p-input-icon-right width-100">
            <i
              *ngIf="keywordFormInput4.value"
              (click)="clearFilter4()"
              id="search-keyword"
              class="text-danger pi pi-fw pi-times-circle cursor-pointer"
            >
            </i>
            <input
              id="inputtext-right"
              pInputText
              [formControl]="keywordFormInput4"
              [readonly]="readOnlyInput"
              min="0"
              [type]="typeInput4"
              oninput="validity.valid||(value='');"
              (keyup)="enterSearch($event)"
              class="input-filters"
            />
            <label for="inputtext-right">{{ placeHolder4 }}</label>
          </span>
        </div>

        <div [class]="classInputText5" *ngIf="showInput5">
          <span class="p-float-label p-input-icon-right width-100">
            <i
              *ngIf="keywordFormInput5.value"
              (click)="clearFilter5()"
              id="search-keyword"
              class="text-danger pi pi-fw pi-times-circle cursor-pointer"
            >
            </i>
            <input
              id="inputtext-right"
              pInputText
              [formControl]="keywordFormInput5"
              [readonly]="readOnlyInput"
              min="0"
              [type]="typeInput5"
              oninput="validity.valid||(value='');"
              (keyup)="enterSearch($event)"
              class="input-filters"
            />
            <label for="inputtext-right">{{ placeHolder5 }}</label>
          </span>
        </div>

        <!-- AUTOCOMPLETES -->
        <div *ngIf="showAutoComplete" [class]="classAutoComplete">
          <div class="flex align-items-center width-100">
            <fast-autocomplete
              (keyup)="enterSearch($event)"
              [showDropDown]="false"
              [useToSearch]="true"
              class="width-100"
              [readonly]="checkAutoComplete.value"
              [control]="keywordAutoComplete"
              [entityService]="clienteService"
              [placeholder]="placeHolderAutoComplete"
              [displayWithEntityFn]="parceiroDisplay"
              [domain_id]="tokenService.getDomain().id"
              displayField="parceiro.nome_razao_social"
              displaySecondField="parceiro.cpf_cnpj"
              [actionState]="false"
              [autoFirst]="false"
              (selectEntity)="onSearch()"
              [searchFieldPath]="'consumidor_final'"
              [searchField]="true"
              [include]="['parceiro']"
              [domainPath]="'parceiro.domain_id'"
              [insertType]="'cliente'"
              [pageValue]="'0'"
              [pageSizeValue]="'20'"
            ></fast-autocomplete>
            <i
              *ngIf="keywordAutoComplete.value"
              (click)="clearFilterAutoComplete()"
              id="search-keyword"
              class="ml-2 mb-2 text-danger pi pi-fw pi-times-circle cursor-pointer"
            >
            </i>
          </div>
          <mat-checkbox
            *ngIf="showCheckBoxNotClient"
            [formControl]="checkAutoComplete"
            color="primary"
          >
            Sem cliente
          </mat-checkbox>
        </div>

        <div [class]="classAutoCompleteSecond" *ngIf="showAutoCompleteSecond">
          <fast-autocomplete
            class="width-100"
            (keyup)="enterSearch($event)"
            [showDropDown]="false"
            [useToSearch]="true"
            [control]="keywordAutoCompleteSecond"
            [entityService]="fornecedorService"
            [placeholder]="placeHolderAutoCompleteSecond"
            [domain_id]="tokenService.getDomain().id"
            [displayWithEntityFn]="parceiroDisplay"
            displayField="parceiro.nome_razao_social"
            displaySecondField="parceiro.cpf_cnpj"
            [actionState]="false"
            [autoFirst]="false"
            (selectEntity)="onSearch()"
            [include]="['parceiro']"
            [domainPath]="'parceiro.domain_id'"
            [insertType]="'fornecedor'"
            [pageValue]="'0'"
            [pageSizeValue]="'20'"
          ></fast-autocomplete>

          <i
            *ngIf="keywordAutoCompleteSecond.value"
            (click)="clearFilterAutoComplete2()"
            id="search-keyword"
            class="ml-2 mb-2 text-danger pi pi-fw pi-times-circle cursor-pointer"
          >
          </i>
        </div>

        <!-- SELECTS -->

        <p-dropdown
          *ngIf="showInputSelect1"
          [class]="classInputSelect1"
          [(ngModel)]="selectedValue"
          [formControl]="keywordSelect1"
          [options]="selectOptions1"
          [placeholder]="placeHolderSelect1"
          optionLabel="viewValue"
          [showClear]="true"
          (onClear)="clearFilterSelect1()"
        >
        </p-dropdown>

        <p-dropdown
          *ngIf="showInputSelect2"
          [class]="classInputSelect2"
          [(ngModel)]="selectedValue2"
          [formControl]="keywordSelect2"
          [options]="selectOptions2"
          [placeholder]="placeHolderSelect2"
          optionLabel="viewValue"
          [showClear]="true"
          (onClear)="clearFilterSelect2()"
        >
        </p-dropdown>

        <p-dropdown
          *ngIf="showInputSelect3"
          [class]="classInputSelect3"
          [(ngModel)]="selectedValue3"
          [formControl]="keywordSelect3"
          [options]="selectOptions3"
          [placeholder]="placeHolderSelect3"
          optionLabel="viewValue"
          [showClear]="true"
          (onClear)="clearFilterSelect3()"
        >
        </p-dropdown>

        <!-- INPUTS DE DATA -->

        <div *ngIf="showInputDate1" [class]="classInputDate1">
          <p-calendar
            dateMask
            [placeholder]="labelInputDate1"
            [formControl]="keywordFormDate1"
            dateFormat="dd/mm/yy"
            [maxDate]="maxDate"
            (onSelect)="onSearch()"
            (keyup)="enterSearch($event)"
            [showIcon]="true"
            inputId="icon"
          >
          </p-calendar>

          <i
            *ngIf="keywordFormDate1.value"
            (click)="clearFilterDate1()"
            id="search-keyword"
            class="ml-2 text-danger pi pi-fw pi-times-circle cursor-pointer"
          >
          </i>
        </div>
        <div *ngIf="showInputDate2" [class]="classInputDate2">
          <p-calendar
            dateMask
            [placeholder]="labelInputDate2"
            [formControl]="keywordFormDate2"
            dateFormat="dd/mm/yy"
            [maxDate]="maxDate"
            (onSelect)="onSearch()"
            (keyup)="enterSearch($event)"
            [showIcon]="true"
            inputId="icon"
          >
          </p-calendar>
          <i
            *ngIf="keywordFormDate2.value"
            (click)="clearFilterDate2()"
            id="search-keyword"
            class="ml-2 text-danger pi pi-fw pi-times-circle cursor-pointer"
          >
          </i>
        </div>

        <div *ngIf="showInputDateRange" [class]="classInputDateRange">
          <p-calendar
            dateMask
            placeholder="Faixa de datas"
            selectionMode="range"
            [formControl]="keywordFormDateRange"
            dateFormat="dd/mm/yy"
            [maxDate]="maxDate"
            [showIcon]="true"
            inputId="range"
          >
          </p-calendar>
          <i
            *ngIf="keywordFormDateRange.value"
            (click)="clearFilterDateRange()"
            id="search-keyword"
            class="ml-2 text-danger pi pi-fw pi-times-circle cursor-pointer"
          >
          </i>
        </div>
      </div>
    </div>

    <div
      [class]="
        multipleInputs
          ? 'w-6 d-flex justify-content-between justify-content-md-start align-items-baseline'
          : 'w-3 d-flex justify-content-between justify-content-md-start align-items-baseline'
      "
    >
      <div class="mr-md-5 viggo-core-view-type">
        <ng-container *ngTemplateOutlet="prefixTemplateViewMode"></ng-container>
        <viggo-core-controls-view-type
          [mobileOnly]="mobileOnly"
          [desktopOnly]="desktopOnly"
          (onChangeViewMode)="changePreviewType($event)"
        ></viggo-core-controls-view-type>
        <ng-container *ngTemplateOutlet="suffixTemplateViewMode"></ng-container>
      </div>
      <viggo-core-controls-action
        [showSearchButton]="showSearchButton"
        [showDownloadButton]="showDownloadButton"
        [showInfoButton]="showInfoButton"
        [showReloadButton]="showReloadButton"
        [showLinkButton]="showLinkButton"
        [showClearFilters]="!disableFilter()"
        (onSearchClick)="onSearch()"
        (onClearFilters)="onClearKeyword()"
        (onReloadClick)="onReloadClick.emit()"
        (onDownloadDataClik)="onDownloadDataClik.emit()"
        (onChangeInfoClik)="onChangeInfoClik.emit()"
        (onChangeLinkClik)="onChangeLinkClik.emit()"
      >
      </viggo-core-controls-action>
    </div>
  </div>

  <mat-progress-bar
    *ngIf="showLoadingBar"
    mode="indeterminate"
    class="progress"
  ></mat-progress-bar>
</mat-card>
